var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedArabEmirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 40.0001C31.046 40.0001 40.0003 31.0458 40.0003 20.0001C40.0003 8.95443 31.046 0.00012207 20.0003 0.00012207C8.95464 0.00012207 0.000335693 8.95443 0.000335693 20.0001C0.000335693 31.0458 8.95464 40.0001 20.0003 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3046 26.9565L13.0438 38.7562C15.2103 39.5602 17.5538 40.0001 20.0003 40.0001C28.5995 40.0001 35.9304 34.5726 38.7562 26.9565H11.3046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3046 13.0435L13.0438 1.24383C15.2103 0.439844 17.5538 0 20.0003 0C28.5995 0 35.9304 5.4275 38.7562 13.0435H11.3046Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 20C3.05176e-05 28.5993 5.42761 35.9302 13.0435 38.7561V1.24402C5.42761 4.06988 3.05176e-05 11.4007 3.05176e-05 20Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedArabEmirates);
export default __webpack_public_path__ + "static/media/united_arab_emirates.f40eec7f93cfca63064f5663be8e4e06.svg";
export { ForwardRef as ReactComponent };